<div class="pdf-page app-aul-036-24" id="aul03624">
  <!-- <app-policy-header></app-policy-header>-->
  <p class="font-large" style="text-align: center"><b> EIFS Exclusion </b></p>
  <br />
  <p class="font-medium">
    <b>THIS ENDORSEMENT CHANGES THE POLICY. PLEASE READ CAREFULLY.</b>
  </p>

  <p class="font-small">
    This endorsement modifies insurance provided under the following forms.
    <br />
    CAUSES OF LOSS - SPECIAL FORM <br />
    CAUSES OF LOSS - BROAD FORM <br />
    CAUSES OF LOSS - BASIC FORM <br />
  </p>
  <br />
  <p class="font-small">
    The following <b>EIFS Exclusion </b> is added to this policy:
  </p>
  <p class="font-small">
    We will not pay for loss or damage to or resulting from design, manufacture
    or use of any exterior insulation finish system ("ElFS"), or any product
    that is a component of an EIFS system including DRYVIT
  </p>
  <br />
  <p class="font-small">
    According to the definitions of the International Building Code and ASTM
    lnternational, an Exterior lnsulation and Finish System (EIFS) is a non-load
    bearing, exterior wall cladding system that consists of an insulation board
    attached either adhesively or mechanically, or both, to the substrate; an
    integrally reinforced base coat; and a textured protective finish coat.
  </p>
  <br />
  <p class="font-small">
    <b>All other terms and conditions of this policy remain unchanged.</b>
  </p>
</div>
